import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import guaranteeImageSrc from '../../assets/images/subscription/guarantee-new.png';
import styles from './GuaranteeBlock.css';

const cx = classnames.bind(styles);

function GuaranteeBlock({
    className
}) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <div className={classes}>
            <img
                alt='guarantee'
                src={guaranteeImageSrc}
                className={styles.guaranteeImage}
            />
            <p className={styles.title}>30-day money-back guarantee</p>
            <p className={styles.description}>
                Our plan is backed by a money-back guarantee. We believe that our plan will work for you, that we guarantee a full refund within 30 days after purchase if you don't see visible results in your ability to reduce negative effects despite following your plan as directed.
                Find more about applicable limitations in our money-back policy.
            </p>
        </div>
    )
};

GuaranteeBlock.propTypes = {
    className: PropTypes.string
};

GuaranteeBlock.defaultProps = {
    className: ''
};

export {
    GuaranteeBlock
};
